export default "__VITE_ASSET__$$BwOE7W__"